export default __webpack_public_path__ + "static/media/inter-v2-latin-regular.fdc0fe56.ttf";